import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_PREFIX = 'MARISA_SERVICOS_';

class LocalStorage {
  static async set(key: string, value: any): Promise<void> {
    if (value) {
      await AsyncStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
    }
  }

  static async remove(key: string): Promise<void> {
    await AsyncStorage.removeItem(STORAGE_PREFIX + key);
  }

  static async get<T = any>(key: string): Promise<T | undefined> {
    const response = await AsyncStorage.getItem(STORAGE_PREFIX + key);
    if (response) {
      return await JSON.parse(response);
    }
    return undefined;
  }

  static async clear(): Promise<any> {
    const keys = await AsyncStorage.getAllKeys();
    await AsyncStorage.multiRemove(
      keys.filter((key) => key.startsWith(STORAGE_PREFIX))
    );
  }
}
export { LocalStorage };
